import type { PH_FEATURES } from './generated';

export namespace PostHog_Features {
    export type Name = keyof typeof PH_FEATURES;
    export type Variant<T extends PostHog_Features.Name> = (typeof PH_FEATURES)[T][number];
}

export const PostHog_OVERRIDES: {
    [Flag in PostHog_Features.Name]?: PostHog_Features.Variant<Flag>;
} = {
    'plp-extra-filters': 'enabled',
    'plp-filter-sidebar': 'sidebar',
    // 'simplified-checkout': 'simplified',
};
